export const LIST_FOUNDATION_MODELS = `
  query ListFoundationModels {
    listFoundationModels {
      modelId
      modelArn
      modelName
      providerName
      pricing {
        inputPricePerMillion
        outputPricePerMillion
        refreshedAt
        region
        endpoint
      }
      approvalScopes {
        scopeKey
        accountId
        accountName
        region
        status
        rationale
        approvedAt
        approvedBy
        implementedAt
        implementedBy
        taskId
      }
    }
  }
`
